import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ExemptionFields from './ExemptionFields'

export const ExemptionEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <ExemptionFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default ExemptionEdit
